import api from "../../api/api";
import { SuperAdminDashboardData, BroadcastRequest, BroadcastResponse } from "../../types/super-admin.types";

class SuperAdminService {
  async getDashboardData(period: string = 'monthly'): Promise<SuperAdminDashboardData> {
    try {
      const response = await api.get('/super-admin/dashboard', {
        params: { period }
      });
      return response.data.data;
    } catch (error) {
      // Hata yönetimi burada veya çağıran yerde yapılabilir.
      // Şimdilik hatayı yukarıya iletiyoruz.
      throw error;
    }
  }

  async sendBroadcast(broadcastData: BroadcastRequest): Promise<BroadcastResponse> {
    try {
      const response = await api.post('/super-admin/broadcast', broadcastData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Şirketleri listele (broadcast'ta seçim için)
  async getCompanies(): Promise<any[]> {
    try {
      const response = await api.get('/companies');
      return response.data.data || [];
    } catch (error) {
      throw error;
    }
  }

  // Şirket adminlerini getir
  async getCompanyAdmins(companyId: number): Promise<Array<{ id: number; firstName: string; lastName: string; email: string; role: string }>> {
    try {
      const response = await api.get(`/super-admin/company/${companyId}/admins`);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }

  // Admin olarak giriş (impersonation)
  async impersonate(targetUserId: number): Promise<{ user: any; token: string }> {
    try {
      const response = await api.post(`/super-admin/impersonate`, { targetUserId });
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }

  // İmpersonation'ı durdur (opsiyonel backend ucu)
  async stopImpersonation(): Promise<void> {
    try {
      await api.post(`/super-admin/impersonate/stop`);
    } catch (error) {
      // Backend henüz bu ucu sağlamazsa sessizce yoksay
      // Konsola düşürmek isterseniz yorum satırını kaldırın
      // console.warn('stopImpersonation not available on backend yet', error);
    }
  }

  // === SÜPER ADMİN KULLANICI YÖNETİMİ ===
  
  // Süper admin kullanıcılarını listele
  async getSuperAdminUsers(): Promise<any[]> {
    try {
      const response = await api.get('/super-admin/users');
      return response.data.data.users || [];
    } catch (error) {
      throw error;
    }
  }

  // Yeni süper admin kullanıcısı oluştur
  async createSuperAdminUser(userData: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    permissions: string[];
  }): Promise<any> {
    try {
      const response = await api.post('/super-admin/users', userData);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }

  // Süper admin kullanıcısını güncelle
  async updateSuperAdminUser(userId: number, userData: {
    email?: string;
    firstName?: string;
    lastName?: string;
    permissions?: string[];
  }): Promise<any> {
    try {
      const response = await api.put(`/super-admin/users/${userId}`, userData);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }

  // Süper admin kullanıcısını sil
  async deleteSuperAdminUser(userId: number): Promise<void> {
    try {
      await api.delete(`/super-admin/users/${userId}`);
    } catch (error) {
      throw error;
    }
  }

  // === CİHAZ ÇAKIŞMA LOGLARI ===

  async getDeviceConflictLogs(): Promise<any[]> {
    try {
      const response = await api.get('/super-admin/device-conflicts');
      return response.data.data || [];
    } catch (error) {
      throw error;
    }
  }

  // Süper admin kullanıcısının şifresini sıfırla
  async resetSuperAdminPassword(userId: number, newPassword: string): Promise<void> {
    try {
      const response = await api.post(`/super-admin/users/${userId}/reset-password`, { 
        password: newPassword 
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // === SÜPER ADMİN ŞİRKET YÖNETİMİ ===
  
  // Süper admin tarafından yeni şirket oluştur
  async createCompany(companyData: {
    name: string;
    email?: string;
    phone?: string;
    address?: string;
    city?: string;
    district?: string;
    zipCode?: string;
    taxNumber?: string;
    taxOffice?: string;
  }): Promise<any> {
    try {
      const response = await api.post('/super-admin/companies', companyData);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
}

const superAdminService = new SuperAdminService();
export default superAdminService; 